export default {
  /**
   * Save user object in vuex state
   * @param state
   * @param {Object|null} user
   */
  setUser(state, { user }) {
    // TODO: EVESSIO-9236 - Standardize AR schemas
    if (user && user.uuid) {
      user.user_uuid = user.uuid;
    }
    state.user = user;

    if (!state.email && user && user.user_email) {
      state.email = user.user_email.toLowerCase();
    }

    if (user && user.user_email) {
      state.domain = user.user_email.split("@")[1].toLowerCase();
    }

    if (user && user.first_digital_event_login) {
      state.firstLogin = user.first_digital_event_login;
    }
  },

  /**
   * Update User profile data
   * @param state
   * @param {Object} profileData
   */
  updateUserProfile(state, profileData) {
    state.user.profile = profileData;
  },

  /**
   * Save User Roles in vuex state
   * @param state
   * @param {Object|null} user
   */
  setUserRoles(state, { roles }) {
    state.userRoles = roles;
  },

  /**
   * Save short user info in vuex state
   * @param state
   * @param {Object} userInfo
   */
  setUserInfo(state, { userInfo }) {
    state.userInfo = userInfo;
  },

  setUserFirstLogin(state, { firstLogin }) {
    state.firstLogin = firstLogin;
  },

  /**
   * Save user email in vuex state
   * @param state
   * @param {String} email
   */
  setEmail(state, { email }) {
    state.email = email;
  },

  setUserConnections(state, data) {
    state.userConnections = data;
  },

  /**
   * User profile. `Me` tab. Toggle tab state. Edit | View
   * @param state
   * @param value. Edit | View
   */
  changeUserProfileTabState(state, value) {
    state.userProfileTabState = value;
  },

  addUserConnection(state, data) {
    state.userConnections.push(data);
  }
};
